export default {
  lastUsed: null,
  isFavorite: false,
  isDefault: false,
  counter: 0,
  uuid: null,
  provider: "RMV",
  from: {
    items: [],
    station: null
  },
  to: {
    items: [],
    station: null
  }
};
